import { Component, HostListener, ChangeDetectionStrategy, OnInit, inject } from '@angular/core';
import { WindowMessageService, PostMessageService, UserDataService } from './shared/messaging';
import { AnalyticsHelper } from './shared/analytics/analytics-helper';

@Component({
  selector: 'app-root',
  template: `<app-layout></app-layout>`,
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
})
export class AppComponent implements OnInit {
  private readonly messageService = inject(WindowMessageService);
  private readonly postMessageService = inject(PostMessageService);
  private readonly userDataService = inject(UserDataService);
  private readonly recentViolations = new Set<string>();

  constructor() {
    this.messageService.acceptMessage(null);
    this.postMessageService.initialize();
    this.userDataService.initialize();
  }

  ngOnInit(): void {
    // read and report stashed csp violations from index.html
    const events = (globalThis as object)['_cspViolations'] || [];
    for (const ev of events) this.handleSecurityViolation(ev, true);
  }

  // listen for CSP security violation events and log them to analytics
  @HostListener('document:securitypolicyviolation', ['$event'])
  handleSecurityViolation(event: SecurityPolicyViolationEvent, fromIndex: boolean = false) {
    // debounce repeated violations
    const violationKey = `${event.violatedDirective}-${event.blockedURI}`;
    if (this.recentViolations.has(violationKey)) return;
    this.recentViolations.add(violationKey);
    setTimeout(() => this.recentViolations.delete(violationKey), 5000);

    // try to decipher a useful `sourceFile`
    let sourceFile = fromIndex ? 'index.html' : event.sourceFile;
    if (sourceFile?.endsWith(location.origin) === true) sourceFile = '';
    const sourceInfo = sourceFile ? `${sourceFile}:${event.lineNumber}:${event.columnNumber}` : 'unknown';

    // try to decipher a useful `documentUri`
    const documentURI = (event.target as HTMLDocument)?.documentURI ?? event.documentURI;
    const message = `violation=${event.violatedDirective}; blockedUri=${event.blockedURI}; source=${sourceInfo}`;
    const detail = {
      violation: event.violatedDirective,
      blockedURI: event.blockedURI,
      documentURI: documentURI,
      currenthash: fromIndex ? undefined : location.hash,
      sourceFile: sourceFile || undefined,
      lineNumber: sourceFile ? event.lineNumber : undefined,
      columnNumber: sourceFile ? event.columnNumber : undefined,
      sample: event.sample || undefined,
    };

    AnalyticsHelper.logEvent({
      action: 'security-violation',
      name: event.violatedDirective,
      message: message,
      detail: detail,
    });

    console.warn('CSP Violation', detail);
  }
}
